<template>
  <UButton
    icon="i-heroicons-share"
    class="lg:hidden"
    size="xl"
    color="gray"
    variant="ghost"
    :aria-label="t('menu.share_menu.button_aria')"
    @click="isOpen = true"
  />
  <UModal v-model="isOpen">
    <UCard>
      <TModalClose @close="isOpen = false" />
      <div class="mt-5">
        <TText
          size="lg"
          tag="div"
          variant="semibold"
          color="gray900"
          classes="ml-2 mb-6"
        >
          {{ t('menu.share_menu.title') }}
        </TText>
        <MenuShareButtons />
      </div>
    </UCard>
  </UModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const isOpen = ref(false)
const { t } = useI18n()
</script>
